module.exports = __webpack_public_path__ + "img/system-2.045bd32.png";